module.exports = __webpack_public_path__ + "img/Duck.9efec680.png";